import React from 'react';
import { Accordion as DSAccordion } from '@/components/shared';
import { AccordionComponentProps } from './register';

/**
 * CMS Accordion component, used for showing CMS content in an accordion
 */
export const Accordion: React.FunctionComponent<AccordionComponentProps> = ({
	title,
	children,
	isDefaultExpanded,
	attributes,
}) => {
	return (
		<div {...attributes} key={'accordion'}>
			<DSAccordion title={title} id={attributes.key} isExpanded={isDefaultExpanded}>
				{children}
			</DSAccordion>
		</div>
	);
};
